import React from "react";
import bg_footer_arabic from "../../assets/img/bg_footer_arabic.png";
import bg_footer_english from "../../assets/img/bg_footer_english.png";

// import backgroundFooter_mob from "../../assets/img/Background3_Mob.png";

interface IProps {
  language: Language
}
export const Footer = (props: IProps) => {
  // const [screenWidth, setScreenWidth] = React.useState<number>(window.innerWidth);
  // window.addEventListener("resize", (e: any) => setScreenWidth(e.target.innerWidth));

  return (
    <div style={{ display: "flex", width: '100%' }}>
      {/* {screenWidth > 700 ? ( */}
      <img
        src={props.language === "Arabic" ? bg_footer_arabic : bg_footer_english}
        className={"jss_27"}
        alt='Footer'
      />
      {/* ) : (
        <img src={backgroundFooter_mob} className={"jss_12"} alt='Footer' />
      )} */}
    </div>
  );
};
